import { z } from 'zod';

// ─── Response schemas ─────────────────────────────────────────────────────────

export const AuditEventResponseSchema = z.object({
  id: z.string().uuid(),
  userId: z.string().uuid().nullable(),
  actingUserId: z.string().uuid().nullable(),
  eventType: z.string().min(1),
  entityType: z.string().nullable(),
  entityId: z.string().nullable(),
  payload: z.record(z.unknown()),
  createdAt: z.string(),
});
export type AuditEventResponse = z.infer<typeof AuditEventResponseSchema>;

export const ListAuditEventsResponseSchema = z.object({
  ok: z.literal(true),
  items: z.array(AuditEventResponseSchema),
  total: z.number().int().nonnegative(),
  limit: z.number().int().positive(),
  offset: z.number().int().nonnegative(),
});
export type ListAuditEventsResponse = z.infer<typeof ListAuditEventsResponseSchema>;

// ─── Query schemas ────────────────────────────────────────────────────────────

export const ListAuditEventsQuerySchema = z.object({
  eventType: z.string().optional(),
  entityType: z.string().optional(),
  userId: z.string().uuid().optional(),
  actingUserId: z.string().uuid().optional(),
  dateFrom: z.string().optional(),
  dateTo: z.string().optional(),
  limit: z.coerce.number().int().positive().max(200).default(50),
  offset: z.coerce.number().int().nonnegative().default(0),
});
export type ListAuditEventsQuery = z.infer<typeof ListAuditEventsQuerySchema>;
